'use client'

// Mixpanel is intentionally disabled.
// Keep this module as a no-op compatibility layer so we can swap in PostHog later
// without touching every call site in one go.

export default function Mixpanel() {
  return null
}

export function trackClick(_event, _trackingData = {}) {
  // Intentionally disabled.
}

export function trackEvent(_eventName, _trackingData = {}) {
  // Intentionally disabled.
}
